/* eslint-env browser */
const ready = (fn: () => void): void => {
  if (document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

export default ready;
